import { forwardRef } from 'react';
import { Link } from 'react-router';
import type { UILinkProps } from '@athlete/ui';

/** Adapts the router's Link to the design system's router-agnostic link contract. */
export const RouterLink = forwardRef<HTMLAnchorElement, UILinkProps>(function RouterLink({ href, ...props }, ref) {
  return <Link ref={ref} to={href} {...props} />;
});
